module.exports = __webpack_public_path__ + "media/images/yamori_info_bg-bea3fe675f2fa63c2868dea693e9a8a8.png";